/* Divine Hindu — "Deals live now" strip (sections/dh-divine-picks.liquid), Oct 2026.
   Each day of the week has its own collection (Monday: Lord Shiva, Tuesday: Hanuman Ji, ...), set in the theme editor.
   This script picks today's collection by India time (IST), loads its cards from /collections/<handle>?view=dh-deals
   (templates/collection.dh-deals.liquid), runs the countdown to 12 AM IST and switches to the next day's picks at
   midnight. The + buttons, steppers and option chooser are handled by assets/dh-divine-picks.js. */
(function () {
  function ist() { var d = new Date(); return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function boot(root) {
    if (!root || root.__ddl) return;
    root.__ddl = true;
    var cfg;
    try { cfg = JSON.parse(root.querySelector('[data-ddl-cfg]').textContent); } catch (e) { return; }
    var days = cfg.days || [];
    var rail = root.querySelector('[data-dpx-rail]');
    var dayEl = root.querySelector('[data-ddl-day]');
    var explore = root.querySelector('[data-ddl-explore]');
    var all = root.querySelector('[data-ddl-all]');
    var allTxt = root.querySelector('[data-ddl-all-t]');
    var clock = root.querySelector('[data-ddl-clock]');
    var cur = -1, loading = 0;

    function label(day) { return (cfg.btn || 'See all {deity} specials').replace('{deity}', day.n || '').replace(/\s+/g, ' ').trim(); }

    function show(html, token) {
      if (token !== loading) return;
      var box = document.createElement('div');
      box.innerHTML = html || '';
      var cards = Array.prototype.slice.call(box.querySelectorAll('.ddl-card'), 0, cfg.count || 10);
      if (!cards.length) { root.hidden = true; return; }
      var tag = String(cfg.label || '').replace(/^\s+|\s+$/g, '');
      rail.innerHTML = '';
      cards.forEach(function (c) {
        /* the label set in the theme editor ("Sale") goes on every card, in place of the product's own badge */
        var media = tag && c.querySelector('.ddl-card__media');
        if (media) {
          var old = media.querySelector('.ddl-card__badge');
          if (old) old.parentNode.removeChild(old);
          var el = document.createElement('span');
          el.className = 'ddl-card__badge ddl-card__badge--sale';
          el.textContent = tag;
          media.insertBefore(el, media.querySelector('.ddl-card__act'));
        }
        rail.appendChild(c);
      });
      rail.scrollLeft = 0;
      root.classList.add('ddl--loaded');
      root.hidden = false;
      try { rail.dispatchEvent(new Event('scroll')); } catch (e) {}
      /* show − 1 + on items that are already in the cart, from the cart the page already knows
         (assets/dh-divine-picks.js); if it is not known yet, it paints these cards when it arrives */
      if (window.DHPicks && typeof window.DHPicks.paint === 'function') window.DHPicks.paint(rail);
    }

    function setDay(force) {
      var dow = ist().getDay();
      if (dow === cur && !force) return;
      cur = dow;
      var day = days[dow] || {};
      if (!day.u) { root.hidden = true; return; }
      if (dayEl) dayEl.textContent = (day.d ? day.d + ' · ' : '') + (day.n || '');
      if (explore) explore.setAttribute('href', day.u);
      if (all) all.setAttribute('href', day.u);
      if (allTxt) allTxt.textContent = label(day);
      var url = day.u + (day.u.indexOf('?') > -1 ? '&' : '?') + 'view=dh-deals';
      var token = ++loading;
      var pre = window.__ddlPrefetch && window.__ddlPrefetch[url];
      if (pre) delete window.__ddlPrefetch[url];
      (pre || fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }))
        .then(function (html) { show(html, token); }, function () { show('', token); });
    }

    function tick() {
      var t = ist();
      if (t.getDay() !== cur) setDay(false);
      if (!clock) return;
      var next = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1, 0, 0, 0, 0);
      var s = Math.max(0, Math.floor((next - t) / 1000));
      clock.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    }

    setDay(true);
    if (cfg.timer && clock) { tick(); setInterval(tick, 1000); }
    else { setInterval(function () { if (ist().getDay() !== cur) setDay(false); }, 60000); }
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ddl]'), boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target && e.target.querySelector('[data-ddl]'); if (r) boot(r); });
})();
